export const CURRENT_CONFIG = {

  // license
  appId: '194489', // You need to go to the development website to apply.
  appKey: 'a71651d9a42737e3f7aded84ca4e1be', // You need to go to the development website to apply.
  appLicense: 'Ird8p3Ru+z3ErRtpeizQtv3vuLTssJQkCZFIO3vmzj+AgcyUGvZExo/dSVOetDKYsyhYDhIf2FooZK5AYktH7W0ly2Gco5mV38ZKFjXiQIX4RQyoNC3uCerpzmHWcfoSR/3jkb7CjzYQPkL17zEe3Bhskb50HGWJnbACUH8gR5I=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://stream.ffbona.de/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://stream.ffbona.de/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://stream.ffbona.de:1935/app/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
